import { mixpanelObject } from './analytics';
import {
  MIXPANEL_CAROUSAL_NAME,
  MIXPANEL_CAROUSAL_ID,
  MIXPANEL_VERTICAL_INDEX,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_POP_UP_TYPE,
  MIXPANEL_TAB_NAME,
  MIXPANEL_SHOW_DETAILS,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_LANDING_PAGE_NAME,
  MIXPANEL_ZEE5_COUNTRY,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_DROPDOWN,
  MIXPANEL_ELEMENT,
  MIXPANEL_EPISODE_LIST,
  MIXPANEL_SERIES,
  MIXPANEL_SORT
} from './analytics/mixpanel/mixpanelConstants';
import { ctaEvent } from './analytics/mixpanel/mixpanelEventsHelper';

// Trigger mixpanel event on click dropdown.
export const triggerMixpanelForCTAEvent = (
  triggerMixpanelFlag: boolean,
  seriesTitle: string,
  country?: string
) => {
  if (triggerMixpanelFlag) {
    mixpanelObject[MIXPANEL_CAROUSAL_NAME] = 'N/A';
    mixpanelObject[MIXPANEL_CAROUSAL_ID] = 'N/A';
    mixpanelObject[MIXPANEL_VERTICAL_INDEX] = 'N/A';
    mixpanelObject[MIXPANEL_HORIZONTAL_INDEX] = 'N/A';
    mixpanelObject[MIXPANEL_POP_UP_NAME] = 'N/A';
    mixpanelObject[MIXPANEL_POP_UP_TYPE] = 'N/A';
    mixpanelObject[MIXPANEL_TAB_NAME] = MIXPANEL_SHOW_DETAILS;
    mixpanelObject[MIXPANEL_PAGE_NAME] = MIXPANEL_SHOW_DETAILS;
    mixpanelObject[MIXPANEL_LANDING_PAGE_NAME] = MIXPANEL_SHOW_DETAILS;
    mixpanelObject[MIXPANEL_ZEE5_COUNTRY] = country?.toUpperCase() || 'N/A';
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_DROPDOWN;
    if (seriesTitle !== '') {
      mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_EPISODE_LIST;
      mixpanelObject[MIXPANEL_SERIES] = seriesTitle;
    } else {
      mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_SORT;
    }
    // Pass series property.
    ctaEvent(true);
    mixpanelObject[MIXPANEL_SERIES] = 'N/A';
  }
};
